const indexItems = [
  { title: '韩漫腐完结全集', desc: '已完结韩漫腐精选', icon: 'ri-check-double-line', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { title: '日漫腐经典必读', desc: '口碑日漫腐合集', icon: 'ri-book-3-line', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { title: '国漫耽美原创', desc: '本土原创耽美佳作', icon: 'ri-brush-3-line', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { title: '校园纯爱专区', desc: '高甜校园恋爱故事', icon: 'ri-hearts-line', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { title: '古风仙侠奇缘', desc: '唯美古风耽美作品', icon: 'ri-moon-line', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { title: '都市总裁系列', desc: '霸道总裁恋爱物语', icon: 'ri-building-2-line', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { title: '奇幻异世界', desc: '魔法与冒险的浪漫', icon: 'ri-magic-line', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { title: 'ABO世界观', desc: 'ABO设定精选作品', icon: 'ri-planet-line', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { title: '悬疑推理耽美', desc: '烧脑与感情交织', icon: 'ri-search-eye-line', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按题材与风格分类，精准找到你爱的腐漫类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className={`group flex items-center gap-3 p-4 md:p-5 rounded-xl border hover:scale-[1.02] transition-all cursor-pointer ${item.color}`}
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-background-50/70 group-hover:bg-background-50 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}